import { getApiOrigin } from '../utils/config';

export const API_HOST = getApiOrigin();
export const ENTITY_PREFIX = 'parcels';
